import Vue from 'vue'

import Button, { ButtonStruct } from './buttons'

export type ButtonType = { type: string, guid:string }

export type ButtonView = { setupView: typeof Vue, buttonView: typeof Vue, propsData?: any }

export type ButtonConfig = { name: string, struct: ButtonType, icon?:string } & ButtonView

export type ButtonData = { guid: string, data: any } & ButtonConfig

export type ButtonsRow = { guid: string, data: Array<ButtonStruct> }

export type ButtonsRows = Array<ButtonsRow>

export type AvailableButtonsTypes = Array<Button | ButtonsGroup>

export enum MoveDirection {
  Back,
  Forward
}

export type ButtonsGroup = {
  name: string
  buttons: Array<Button>
}
